import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Chart from 'chart.js';
import ResultCard from './ResultCard';
import { toEmail } from "../api/quiz2email";
import { getTotalObj, isMeasurableDimension } from '../api/common';
import MessageBox from './MessageBox';
import './../style.css'
import './../css/bootstrap.css'
import './../css/dark.css'
import './../css/font-icons.css'
import './../css/components/ion.rangeslider.css'
import './../css/custom.css'
import './../css/fonts.css'

const Styles = styled.div`
display: flex;
flex-direction: column;
div{
    font-family: 'Corbel', sans-serif; 
    font-size: 1.3rem;
    display: flex;
    flex-direction: column;
    margin: 20px 0;
}
.results{
    display: flex;
    flex-direction: column;
}
.cards{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 15px;
    margin: auto;
}
.cards>*{
    flex: 1;
    border-radius: 15px;
    margin: 5px;
    border: 5px solid #0e6786;
}
h1 {
    font-family: 'Corbel', sans-serif; 
    font-size: 3rem;
    margin: 20px 0;
}
`

const Result = props => {
    const { user, answers, quiz } = props;
    // console.log(JSON.stringify(user));
    // console.log(JSON.stringify(answers));

    const [emailResponse, setEmailResponse] = useState();

    const IMAGES = {
        "resultado": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/icone_resultado_qhryim.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/icone_resultado_idstms.png"],
        "s&op": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943519/quiz_images_svg/sop_uvs87j.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/sop_fcxn8j.png"],
        "s&oe": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/soe_i6iyr1.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/soe_ai1avi.png"],
        "visão e estratégia": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943519/quiz_images_svg/visao_estrategia_vsg18f.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/visao_estrategia_ppjtzg.png"],
        "organização e cultura": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943519/quiz_images_svg/organizacao_cultuta_igylt3.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/organizacao_cultuta_wusxnd.png"],
        "processos": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/processos_hho9w6.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/processos_pq1yrh.png"],
        "indicadores e metas": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/indicadores_metas_enbrfa.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/indicadores_metas_lf6x9p.png"],
        "desenvolvimento humano": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/desenvolvimento_humano_nteram.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/desenvolvimento_humano_zsrfe7.png"],
        "alavancas de valor": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943517/quiz_images_svg/alavancas_valor_mmw3hr.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/alavancas_valor_vjvzda.png"],
        "dados e tecnologia": ["https://res.cloudinary.com/dsswtxtxf/image/upload/v1606943519/quiz_images_svg/dados_tecnologia_caayod.svg",
            "https://res.cloudinary.com/dsswtxtxf/image/upload/v1606945234/quiz_images/dados_tecnologia_fd09p8.png"],
    }

    const allQuestions = quiz.steps.reduce((all, step) => [...all, ...step.questions], [])

    const dimensions = Array.from(new Set(allQuestions.map(q => q.dimension).filter(d => isMeasurableDimension(d))));
    const dimensions_total = dimensions.map(d => getTotalObj(null, d, allQuestions, answers).percentage);

    const SENDMAIL_URL = "https://tecemossendingmail.herokuapp.com/send";

    useEffect(() => {
        setTimeout(() => {
            if (!emailResponse) {
                const email = toEmail(user, allQuestions, dimensions, answers, IMAGES);
                postData(SENDMAIL_URL, {
                    ...email,
                    html: email.adminHtml, to: email.adminTo
                }).then(res => {
                    postData(SENDMAIL_URL, {
                        ...email,
                        html: email.userHtml, to: email.userTo
                    }).then(res => {
                        setEmailResponse(res);
                    });
                });
            }
        }, 2000);

        const data = dimensions_total;

        var barChartData = {
            labels: dimensions,
            datasets: [{
                label: 'Porcentagem por dimensão (%)',
                backgroundColor: '#86160e',
                borderColor: '#444',
                borderWidth: 1,
                data
            }]
        };

        var ctx = document.getElementById("chart-0").getContext("2d");
        new Chart(ctx, {
            type: 'bar',
            data: barChartData,
            options: {
                responsive: true,
                legend: {
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        display: true,
						scaleLabel: {
							display: true,
							labelString: 'Porcentagem (%)'
                        }
                    }],
                    xAxes: [{
						display: true,
						scaleLabel: {
							display: true,
							labelString: ''
						}
					}],
					
                }
            }
        })
    })

    return (
        <Styles>
                <div className="content-wrap">
                    <div className="row mb-0">
                        <h1><span>Resultado</span></h1>
                        <div><strong>Obrigado por responder o questionário de maturidade da cadeia de valor a partir de uma perspectiva dos processos S&OP e S&OE.</strong>
                        Este resultado será enviado ao e-mail informado. Caso não receba em sua caixa de entrada, favor verificar em sua caixa de spam.</div>
                        {emailResponse && emailResponse.Messages && emailResponse.Messages.length > 0 &&
                            emailResponse.Messages[0].Status === 'success' && <MessageBox message="E-mail enviado com sucesso." isSuccess={true} />}

                        <div className="results">
                            <div className="cards">
                                <ResultCard key={0} image={IMAGES["s&op"][0]} stepTitle={"S&OP"} allQuestions={allQuestions} answers={answers} />
                                <ResultCard key={1} image={IMAGES["s&oe"][0]} stepTitle={"S&OE"} allQuestions={allQuestions} answers={answers} />
                            </div>
                        </div>
                    </div>
                </div>

                        <center>
                        <canvas styled="position: center" id="chart-0"></canvas>
                        </center>

                <div className="content-wrap">
                    <div className="row mb-0">
                        <div className="results">
                            <div className="cards">
                                {dimensions.map((d, i) => {
                                    return (
                                        <ResultCard image={IMAGES[d.toLowerCase()] ? IMAGES[d.toLowerCase()][0] : ''} key={i} dimensionTitle={d} allQuestions={allQuestions} answers={answers} />
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>

            <div className="content-wrap">
                <div>Caso tenha interesse em uma análise de maturidade mais detalhada e personalizada para sua empresa, fique à vontade para entrar em contato conosco. Será um prazer!</div>
                <div>Para essa análise, um de nossos consultores entrará em contato para conhecer mais sobre a empresa. Utilizaremos a metodologia do livro “Da Estratégia à Execução”, e forneceremos recomendações para cada um dos processos (S&OP e S&OE) - sempre considerando as 7 dimensões da transformação, e adaptando ao perfil do negócio.</div>
                <div>Para agendar uma conversa, entre em contato por meio de nossos canais de comunicação.</div>
            </div>
        </Styles>
    )
}
export default Result;

async function postData(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return response.json();
}